import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { DatatablePreview, PreviewPanel } from 'ui';
import { LinkButton } from 'ui/Buttons';

export const IssuerDashboardEntitiesWidget = ({ entities, loading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isEmpty = entities.length === 0;
  const handleViewAllClick = !isEmpty ? () => navigate('/credit-rating-coverage/related') : null;

  const columns = [
    {
      label: 'Name',
      options: {
        customBodyRender: (_value, { rowData: [[id, name]] }) => (
          <LinkButton to={`/entities/${id}`} label={name.toUpperCase()} />
        ),
      },
    },
    { label: t('Country') },
    { label: t('Entity rating') },
  ];

  return (
    <PreviewPanel title={t('Our ratings')} onViewAllClick={handleViewAllClick}>
      <DatatablePreview columns={columns} data={entities} loading={loading} />
    </PreviewPanel>
  );
};

IssuerDashboardEntitiesWidget.defaultProps = {
  loading: false,
};

IssuerDashboardEntitiesWidget.propTypes = {
  loading: PropTypes.bool,
  entities: PropTypes.arrayOf(PropTypes.any).isRequired,
};
